import { useState } from "react";
import { useQuery } from "react-query";

import { handleRequestErrors } from "Utils/Errors";

import { listAllClientsBudget } from "Requests/Partners/Budgets";

export interface Filters {
  page_size: string;
  page: number;
  search: string;
  client_id: string;
  start_date: undefined | string;
  end_date: undefined | string;
  status_id: string;
}

export const useGetBudgetsClients = () => {
  const [pageSelected, setPageSelected] = useState(1);

  const [filters, setFilters] = useState<Filters>({
    page_size: "10",
    page: pageSelected,
    search: "",
    client_id: "",
    start_date: undefined,
    end_date: undefined,
    status_id: "",
  });

  const query = useQuery(
    ["clients-budgets-units", filters, pageSelected],
    () => listAllClientsBudget({ ...filters, home_collected: "0" }),
    {
      refetchOnWindowFocus: false,
      onError: (errorRes) =>
        handleRequestErrors({
          reqErrors: errorRes,
          errorMessage: "Não foi possível buscar a listagem de orçamentos.",
        }),
    }
  );

  const setBudgetsFilters = (searchFilter: Filters) => {
    const filtersParams = {
      ...filters,
      ...searchFilter,
      start_date: searchFilter.start_date,
      end_date: searchFilter.end_date,
      page: searchFilter.page ?? 1,
    };
    setFilters(filtersParams);
  };

  function handlePagination(e: { currentPage: number }) {
    if (pageSelected === e.currentPage) return;
    setPageSelected(e.currentPage);
    setFilters((prev) => ({ ...prev, page: e.currentPage }));
  }

  return {
    ...query,
    setBudgetsFilters,
    pagination: { ...query.data?.meta.pagination },
    handlePagination,
  };
};
